// Centralized Crisp (chat) closure configuration.
//
// The Swedish site's chat is switched off for the same summer-2026 window as
// the office phone (see phoneClosureConfig). We reuse the phone-closure dates
// as the single source of truth so the two windows can never drift apart.
import { phoneClosureConfig } from "utils/phoneClosureConfig"

export const crispClosureConfig = {
  // Enable/disable the entire feature (kill switch)
  enabled: true,

  // Reuse the phone-closure window: 3.7.2026 – 2.8.2026 inclusive,
  // chat reappears 3.8.2026.
  startDate: phoneClosureConfig.startDate,
  endDate: phoneClosureConfig.endDate,
}

// Helper function to check if current date is within the closure period.
// Evaluated client-side (like phoneClosureConfig) so the static build's
// compile time never determines what a visitor sees.
export const isCrispClosurePeriod = () => {
  if (!crispClosureConfig.enabled) return false

  const now = new Date()
  const { startDate, endDate } = crispClosureConfig

  // Add one day to endDate to make it inclusive
  const endDateInclusive = new Date(endDate)
  endDateInclusive.setDate(endDateInclusive.getDate() + 1)

  return now >= startDate && now < endDateInclusive
}

// Chat is disabled only on the Swedish site (somebuddy.se), and only within
// the closure window. Finnish and global builds are unaffected.
export const shouldDisableCrisp = () =>
  process.env.GATSBY_SITE_COUNTRY === "se" && isCrispClosurePeriod()
